import MessageTable from "@/app/app-shared/message/table";

export default function WhatsappListingPage(){
    return <MessageTable/>
}